import { render, staticRenderFns } from "./LocationPage.vue?vue&type=template&id=6b5fa2d2&scoped=true&"
import script from "./LocationPage.vue?vue&type=script&lang=js&"
export * from "./LocationPage.vue?vue&type=script&lang=js&"
import style0 from "./LocationPage.vue?vue&type=style&index=0&id=6b5fa2d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fa2d2",
  null
  
)

export default component.exports